export default "__VITE_ASSET__4baYh5jG__"